import {
    Icon,
    IconButton
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { fuelAllowanceService } from '../../../_services/fuelAllowance.service';
import { PaperTableHeader } from '../../../_components/table/header.table';
import { SearchTableHeader } from '../../../_components/table/search.table';
import { StandardTable } from '../../../_components/table/standard.table';
import { TABLE_FILTER } from '../../../_const/tableFilter.const';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { FuelAllowanceManageDrawer } from './fuelAllowance-manageDrawer';
import { StandardPanel } from '../../../_components/panel/standard.panel';
import { get7DaysRange, getDateString } from '../../../_helpers/dateTime.helper';


export function FuelAllowanceIndex() {
    const { centreId } = useParams<{ centreId: string }>();
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState({ ...TABLE_FILTER, ...get7DaysRange(), centreId: centreId });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await fuelAllowanceService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    function download() {
        return fuelAllowanceService.exportReport(centreId, filter.dateFrom, filter.dateTo);
    }


    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 60,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("FuelAllowance/Manage/" + row.original.id) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                size: 30,
                accessorKey: 'date',
                header: 'Date',
                Cell: ({ row }) => (
                    <> {row.original.date ? getDateString(row.original.date) : ""} </>
                )
            },
            {
                size: 100,
                accessorKey: 'userName',
                header: 'Staff',
            },
            {
                size: 100,
                accessorKey: 'carRegistration',
                header: 'Car Registration'
            },
            {
                size: 50,
                accessorKey: 'amount',
                header: 'Amount',
                Cell: ({ row }) => (
                    <> {row.original.amount ? "€ " + row.original.amount : "-"} </>
                )
            },
            {
                size: 80,
                accessorKey: 'status',
                header: 'Status',
                Cell: ({ row }) => (
                    <> {row.original.status ? "Active" : "Inactive"} </>
                )
            },
        ],
        []
    );

    return (
        <>
            <StandardPanel
                title="Fuel Allowance"
                buttons={[
                    { icon: "download", onClick: () => { download();}, disabled: !data.count },
                    { icon: "add", onClick: () => { navigate("FuelAllowance/Create/") } },
                ]} loading={isLoading}>

                <SearchTableHeader inputs={[
                    { label: "Date From", name: "dateFrom", type: "date", onChange: setFilter, value: filter.dateFrom },
                    { label: "Date To", name: "dateTo", type: "date", onChange: setFilter, value: filter.dateTo },
                ]} />
                <StandardTable columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={setFilter}
                    loading={isLoading}></StandardTable>
            </StandardPanel>


            <Routes>
                <Route path="FuelAllowance/Create" element={<FuelAllowanceManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="FuelAllowance/Manage/:id" element={<FuelAllowanceManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
}
